export * from './EllipsisTypography';
